import { useTranslation } from 'react-i18next';

import { TableHead, TableHeader, TableRow } from '@/common/components/ui/table';

export const CarListTableHeader = () => {
  const { t } = useTranslation();

  return (
    <TableHeader>
      <TableRow>
        <TableHead className="text-center rounded-tl-lg border-r border-warm-gray-200 min-w-[92px]">
          {t('garantie.vehiculeNumber')}
        </TableHead>
        <TableHead className="text-center border-r border-warm-gray-200 min-w-[92px]">
          {t('garantie.year')}
        </TableHead>
        <TableHead className="border-r border-warm-gray-200 min-w-[200px]">
          {t('garantie.description')}
        </TableHead>
        <TableHead className="text-center border-r border-warm-gray-200 min-w-[150px]">
          {t('garantie.serialNumber')}
        </TableHead>
        <TableHead className="text-center rounded-tr-lg min-w-[150px]">
          {t('garantie.caracteristics')}
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};
